import { MemoizedSelector, MemoizedSelectorWithProps, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { LoaderError } from '../../../model';
import { PyStateUtils } from '../../../state/utils';
import { StateWithUser, StockInfoState, UserState } from '../user-state';
import { getUserState } from './feature.selector';

export const getStockInfos: MemoizedSelector<StateWithUser, StateUtils.EntityLoaderState<StockInfoState>> = createSelector(
  getUserState,
  (state: UserState) => state && state.stockInfos
);

export const getStockInfoState: MemoizedSelectorWithProps<StateWithUser, any, StockInfoState | undefined> = createSelector(
  getStockInfos,
  (state: StateUtils.EntityLoaderState<StockInfoState>, props) => StateUtils.entityValueSelector(state, props.key)
);

export const getStockInfoLoaderState: MemoizedSelectorWithProps<
  StateWithUser,
  any,
  StateUtils.LoaderState<StockInfoState>
> = createSelector(getStockInfos, (state: StateUtils.EntityLoaderState<StockInfoState>, props) =>
  PyStateUtils.entityLoaderStateSelector(state, props.key)
);

export const getStockInfoStateLoading: MemoizedSelectorWithProps<StateWithUser, any, boolean> = createSelector(
  getStockInfos,
  (state: StateUtils.EntityLoaderState<StockInfoState>, props) => StateUtils.entityLoadingSelector(state, props.key)
);

export const getStockInfoStateSuccess: MemoizedSelectorWithProps<StateWithUser, any, boolean> = createSelector(
  getStockInfos,
  (state: StateUtils.EntityLoaderState<StockInfoState>, props) => StateUtils.entitySuccessSelector(state, props.key)
);

export const getStockInfoStateError: MemoizedSelectorWithProps<StateWithUser, any, LoaderError | undefined> = createSelector(
  getStockInfos,
  (state: StateUtils.EntityLoaderState<StockInfoState>, props) => PyStateUtils.entityErrorDetailsSelector(state, props.key)
);
